import { CropDetails } from '@/lib/model';

export const NEXT_PUBLIC_OWN_DOMAIN_FALLBACK = 'https://trt-global.com';
export const ARTICLE_PER_SITEMAP = 10000;
export const SITE_URL =
  process.env.NEXT_PUBLIC_OWN_DOMAIN || NEXT_PUBLIC_OWN_DOMAIN_FALLBACK;

const siteUrl = {
  development: 'http://localhost:3000',
  test: 'https://test.trtglobal.io',
  staging: 'https://staging.trtglobal.io',
  production: 'https://trt.global',
};
export const SITE_URL_WITH_PROTOCOL =
  siteUrl[process.env.RUNTIME_ENV as keyof typeof siteUrl];

export const IMAGE_RATIO: { ratio: number; type: CropDetails['type'] }[] = [
  { ratio: 16 / 9, type: '16x9' },
  { ratio: 2 / 1, type: '2x1' },
  { ratio: 3 / 2, type: '3x2' },
  { ratio: 4 / 3, type: '4x3' },
  { ratio: 1, type: '1x1' },
  { ratio: 9 / 16, type: '9x16' },
  { ratio: 3 / 4, type: '3x4' },
  { ratio: 2 / 3, type: '2x3' },
  { ratio: 5 / 1, type: '5x1' },
  { ratio: 4 / 1, type: '4x1' },
  { ratio: 3 / 1, type: '3x1' },
];

export const STATIC_ASSETS_URL = 'https://dqf5bb0eem6kl.cloudfront.net';
